import { render, staticRenderFns } from "./sendStrategy.vue?vue&type=template&id=1dd2c288&"
import script from "./sendStrategy.vue?vue&type=script&lang=js&"
export * from "./sendStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports